import * as fromRouter from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';
import * as fromAggregateGraphHub from './aggregate-graph-hub/aggregate-graph-hub.reducer';
import * as fromAuth from './auth/auth.reducer';
import * as fromBodyPartsSearch from './body-parts-search/body-parts-search.reducer';
import * as fromClient from './client/client.reducer';
import * as fromComplicationNameSearch from './complication-name-search/complication-name-search.reducer';
import * as fromInHospitalListGraph from './in-hospital-list-graph/in-hospital-list-graph.reducer';
import * as fromMenuSelection from './menu-selection/menu-selection.reducer';
import * as fromPatientAudit from './patient-audit/patient-audit.reducer';
import * as fromPatientClinicalNote from './patient-clinical-note/patient-clinical-note.reducer';
import * as fromPatientGraph from './patient-graph/patient-graph.reducer';
import * as fromPatientSearch from './patient-search/patient-search.reducer';
import * as fromPatientTask from './patient-task/patient-task.reducer';
import * as fromPatient from './patient/patient.reducer';
import * as fromPlatform from './platform/platform.reducer';
import * as fromServiceGraph from './service-graph/service-graph.reducer';
import * as fromServiceSettings from './service-settings/service-settings.reducer';
import * as fromServiceTask from './service-task/service-task.reducer';
import * as fromSheetGraph from './sheet-graph/sheet-graph.reducer';
import * as fromSheetActionSearch from './sheet-item-search/sheet-item-search.reducer';
import * as fromSheetTemplateManagement from './sheet-template-management/sheet-template-management.reducer';
import * as fromSheetReducer from './sheet/sheet.reducer';
import * as fromUserGraph from './user-graph/user-graph.reducer';
import * as fromUserSearch from './user-search/user-search.reducer';

export interface AppState {
	aggregateGraphHub: fromAggregateGraphHub.State;
	auth: fromAuth.State;
	bodyPartsSearch: fromBodyPartsSearch.State;
	client: fromClient.State;
	complicationNameSearch: fromComplicationNameSearch.State;
	inHospitalListGraph: fromInHospitalListGraph.State;
	menuSelection: fromMenuSelection.State;
	patient: fromPatient.State;
	patientAudit: fromPatientAudit.State;
	patientClinicalNote: fromPatientClinicalNote.State;
	patientGraph: fromPatientGraph.State;
	patientSearch: fromPatientSearch.State;
	patientTask: fromPatientTask.State;
	platform: fromPlatform.State;
	router: fromRouter.RouterReducerState;
	serviceGraph: fromServiceGraph.State;
	serviceSettings: fromServiceSettings.State;
	serviceTask: fromServiceTask.State;
	sheet: fromSheetReducer.State;
	sheetGraph: fromSheetGraph.State;
	sheetItemSearch: fromSheetActionSearch.State;
	sheetTemplateManagement: fromSheetTemplateManagement.State;
	userGraph: fromUserGraph.State;
	userSearch: fromUserSearch.State;
}

export const reducers: ActionReducerMap<AppState> = {
	aggregateGraphHub: fromAggregateGraphHub.aggregateGraphHubReducer,
	auth: fromAuth.authReducer,
	bodyPartsSearch: fromBodyPartsSearch.bodyPartsSearchReducer,
	client: fromClient.clientReducer,
	complicationNameSearch: fromComplicationNameSearch.complicationNameSearchReducer,
	inHospitalListGraph: fromInHospitalListGraph.inHospitalListGraphReducer,
	menuSelection: fromMenuSelection.menuSelectionReducer,
	patient: fromPatient.patientReducer,
	patientAudit: fromPatientAudit.patientAuditReducer,
	patientClinicalNote: fromPatientClinicalNote.patientClinicalNoteReducer,
	patientGraph: fromPatientGraph.patientGraphReducer,
	patientSearch: fromPatientSearch.patientSearchReducer,
	patientTask: fromPatientTask.patientTaskReducer,
	platform: fromPlatform.platformReducer,
	router: fromRouter.routerReducer,
	serviceGraph: fromServiceGraph.serviceGraphReducer,
	serviceSettings: fromServiceSettings.serviceSettingsReducer,
	serviceTask: fromServiceTask.serviceTaskReducer,
	sheet: fromSheetReducer.sheetReducer,
	sheetGraph: fromSheetGraph.sheetGraphReducer,
	sheetItemSearch: fromSheetActionSearch.sheetItemSearchReducer,
	sheetTemplateManagement: fromSheetTemplateManagement.sheetTemplateManagementReducer,
	userGraph: fromUserGraph.userGraphReducer,
	userSearch: fromUserSearch.userSearchReducer
};